// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"24da0ecf9afc5746d4f1","678":"80ec2641827773ac7970","883":"542131a760cedf4b6121"}[chunkId] + ".js";
};